import styled from 'styled-components'

export const InputContainer = styled.div`
  margin-top: 16px;
  width: 100%;

  & > fieldset {
    width: 100%;
    padding: 2px;
  }

  .fieldset__input-wrapper {
    max-width: 100%;
  }
`
